import React from 'react';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconEdit from '@material-ui/icons/Edit';
import IconDelete from '@material-ui/icons/Delete';
import IconAdd from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'ra-core';
import { AddDocumentButton } from './AddDocumentButton';
import { DeleteDocumentButton } from './DeleteDocumentButton';
/**
 * The toolbar displayed at the top of the document view
 */
export const DocumentToolbar = ({ disabled, document, entityType, entityUuid, hasChildren, userCanEdit, userCanAdd, userCanDelete, onEdit, onAddNewDocument, onDeleteDocument, }) => {
    const classes = useStyles();
    const translate = useTranslate();
    if (!document || (!userCanEdit && !userCanDelete)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.root },
            userCanAdd && (React.createElement(AddDocumentButton, { document: document, color: "primary", size: "small", onClick: onAddNewDocument, disabled: disabled, className: classes.button, "aria-label": translate('resources.documents.actions.new_child_document_button'), startIcon: React.createElement(IconAdd, null) }, translate('resources.documents.actions.new_child_document_button'))),
            userCanEdit && (React.createElement(Button, { color: "primary", size: "small", onClick: onEdit, disabled: disabled, className: classes.button, "aria-label": translate('resources.documents.actions.edit_document_button'), startIcon: React.createElement(IconEdit, null) }, translate('resources.documents.actions.edit_document_button'))),
            userCanDelete && (React.createElement(DeleteDocumentButton, { document: document, entityType: entityType, entityUuid: entityUuid, hasChildren: hasChildren, color: "primary", size: "small", onClick: onDeleteDocument, disabled: disabled, className: classes.button, "aria-label": translate('resources.documents.actions.delete_document_button'), startIcon: React.createElement(IconDelete, null) }, translate('resources.documents.actions.delete_document_button')))),
        React.createElement(Divider, null)));
};
const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(1),
    },
    button: {
        '& + &': {
            marginLeft: theme.spacing(2),
        },
    },
}), {
    name: 'Layer7DocumentationToolbar',
});
//# sourceMappingURL=DocumentToolbar.js.map